import React from "react";
import { Link, useParams } from "react-router-dom";
import { useI18n } from "@/i18n/I18nContext";
import { getPosts } from "@/data/blog";
import { Reveal } from "@/components/Reveal";
import { ArrowRight, Clock } from "lucide-react";

const T = {
  it: { kicker: "Blog · Lago di Como", title: "Storie e consigli dal Lago di Como", subtitle: "Guide, itinerari e segreti da local per vivere al meglio Bellagio e il Lago di Como.", read: "min di lettura", readMore: "Leggi l'articolo" },
  en: { kicker: "Blog · Lake Como", title: "Stories and tips from Lake Como", subtitle: "Guides, itineraries and local secrets to make the most of Bellagio and Lake Como.", read: "min read", readMore: "Read the article" },
  fr: { kicker: "Blog · Lac de Côme", title: "Histoires et conseils du lac de Côme", subtitle: "Guides, itinéraires et secrets de locaux pour profiter au mieux de Bellagio et du lac de Côme.", read: "min de lecture", readMore: "Lire l'article" },
};

export default function BlogPage() {
  const { lang } = useI18n();
  const { lang: routeLang } = useParams();
  const l = routeLang || lang;
  const tx = T[l] || T.it;
  const posts = getPosts(l);

  return (
    <>
      <section className="pt-36 pb-12 bg-[#F2EFEB]">
        <div className="max-w-5xl mx-auto px-6 md:px-12">
          <Reveal>
            <div className="text-xs uppercase tracking-[0.3em] text-[#345B73] mb-4">{tx.kicker}</div>
            <h1 className="font-display text-5xl md:text-6xl text-[#1A1A1A] tracking-tight">{tx.title}</h1>
            <p className="mt-5 max-w-2xl text-lg text-[#5C5C5C] leading-relaxed">{tx.subtitle}</p>
          </Reveal>
        </div>
      </section>

      <section className="py-16 md:py-24">
        <div className="max-w-6xl mx-auto px-6 md:px-12">
          <div className="grid md:grid-cols-3 gap-8">
            {posts.map((p, i) => (
              <Reveal key={p.slug} delay={(i % 3) * 80}>
                <Link to={`/${l}/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`}
                  className="group block bg-white rounded-2xl border border-black/5 overflow-hidden h-full hover:shadow-xl transition-shadow">
                  <div className="aspect-[16/10] overflow-hidden">
                    <img src={p.cover} alt={p.title} className="w-full h-full object-cover img-zoom" />
                  </div>
                  <div className="p-6">
                    <div className="flex items-center gap-3 text-xs text-[#5C5C5C] mb-3">
                      <span className="px-2.5 py-1 rounded-full bg-[#1D3557]/10 text-[#1D3557] font-medium">{p.category}</span>
                      <span className="inline-flex items-center gap-1"><Clock className="w-3.5 h-3.5" /> {p.readMin} {tx.read}</span>
                    </div>
                    <h2 className="font-display text-xl text-[#1A1A1A] leading-snug mb-2 group-hover:text-[#345B73] transition-colors">{p.title}</h2>
                    <p className="text-sm text-[#5C5C5C] leading-relaxed mb-4">{p.excerpt}</p>
                    <span className="inline-flex items-center gap-1.5 text-sm font-medium text-[#1D3557]">
                      {tx.readMore} <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                    </span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
